import { titleSortFilters } from "../../../../Components/titleSortFilters"

// Estimated Program Status opens on the busiest descriptors, for Visa and Mastercard alike.
export const DEFAULT_EPS_ORDERING = "-transaction_count"

export const toOrdering = (sorter) => {
  if (!sorter?.order) return null
  return sorter.order === "ascend" ? sorter.field : `-${sorter.field}`
}

export const withEpsSort = (column, { sortable, isText = false, defaultOrdering = null }) => {
  if (!sortable) return column

  const isDefaultColumn = defaultOrdering?.replace(/^-/, "") === column.dataIndex

  return {
    ...column,
    sorter: true,
    ...(isDefaultColumn
      ? { defaultSortOrder: defaultOrdering.startsWith("-") ? "descend" : "ascend" }
      : {}),
    sortDirections: isText ? ["ascend", "descend"] : ["descend", "ascend"],
    title: (state) =>
      titleSortFilters({
        title: column.title,
        sorter: true,
        stateData: state,
        key: column.dataIndex,
        justify: column.align === "right" ? "end" : "start"
      })
  }
}
